// Main JavaScript entry point
// console.log("JavaScript loaded successfully - Mobile carousel ready!");

// Simple mobile carousel implementation
function initializeMobileCarousel() {
  const mobileBreakpoint = 768;

  function initCarousel() {
    const carouselContainers = document.querySelectorAll(
      ".swiper-container.mobile-only"
    );

    console.log("Found carousel containers:", carouselContainers.length);

    carouselContainers.forEach((container) => {
      // Skip if already initialized
      if (container.dataset.carouselInitialized === "true") return;

      const wrapper = container.querySelector(".swiper-wrapper");
      const slides = container.querySelectorAll(".swiper-slide");
      const prevBtn = container.querySelector(".swiper-button-prev");
      const nextBtn = container.querySelector(".swiper-button-next");
      const pagination = container.querySelector(".swiper-pagination");

      if (!wrapper || slides.length === 0) return;

      // Mark as initialized
      container.dataset.carouselInitialized = "true";

      let currentSlide = 0;
      const totalSlides = slides.length;

      // Update slide position
      function updateSlidePosition() {
        // Calculate the total space each slide takes up (width + margin)
        // Slide width: calc(100% - 53px), Margin: 7px
        // Total space per slide: calc(100% - 53px) + 7px = calc(100% - 46px)
        const totalSlideSpace = 100 - (46 / container.offsetWidth) * 100; // Convert 46px to percentage
        const translateX = -currentSlide * totalSlideSpace;
        wrapper.style.transform = `translateX(${translateX}%)`;

        // Update pagination
        if (pagination) {
          const bullets = pagination.querySelectorAll(
            ".swiper-pagination-bullet"
          );
          bullets.forEach((bullet, index) => {
            bullet.classList.toggle(
              "swiper-pagination-bullet-active",
              index === currentSlide
            );
          });
        }

        // Update image counter
        const sectionId = container.id.replace("swiper-gallery-", "");
        const counter = document.querySelector(
          `#MediaGallery-${sectionId} .current_image`
        );
        if (counter) {
          counter.textContent = currentSlide + 1;
        }
      }

      // Navigation functions
      function goToSlide(slideIndex) {
        currentSlide = Math.max(0, Math.min(slideIndex, totalSlides - 1));
        updateSlidePosition();
      }

      function nextSlide() {
        goToSlide(currentSlide + 1);
      }

      function prevSlide() {
        goToSlide(currentSlide - 1);
      }

      // Event listeners with additional safety checks
      if (nextBtn && typeof nextBtn.addEventListener === "function") {
        nextBtn.addEventListener("click", nextSlide);
      }
      if (prevBtn && typeof prevBtn.addEventListener === "function") {
        prevBtn.addEventListener("click", prevSlide);
      }

      // Add pagination click listeners with safety checks
      if (pagination && pagination.querySelectorAll) {
        const bullets = pagination.querySelectorAll(
          ".swiper-pagination-bullet"
        );
        bullets.forEach((bullet, index) => {
          if (bullet && typeof bullet.addEventListener === "function") {
            bullet.addEventListener("click", () => goToSlide(index));
          }
        });
      }

      // Touch/swipe support
      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      // Touch event listeners with safety checks
      if (container && typeof container.addEventListener === "function") {
        container.addEventListener("touchstart", (e) => {
          if (e.touches && e.touches[0]) {
            startX = e.touches[0].clientX;
            isDragging = true;
          }
        });

        container.addEventListener("touchmove", (e) => {
          if (!isDragging || !e.touches || !e.touches[0]) return;
          currentX = e.touches[0].clientX;
          const diffX = startX - currentX;

          if (Math.abs(diffX) > 50) {
            if (diffX > 0) {
              nextSlide();
            } else {
              prevSlide();
            }
            isDragging = false;
          }
        });

        container.addEventListener("touchend", () => {
          isDragging = false;
        });
      }

      // Initialize
      updateSlidePosition();
      console.log("Mobile carousel initialized for:", container.id);
    });
  }

  function handleResize() {
    if (window.innerWidth <= mobileBreakpoint) {
      initCarousel();
    }
  }

  // Initialize on load and resize
  handleResize();
  window.addEventListener("resize", handleResize);
}

// Add your JavaScript code here
document.addEventListener("DOMContentLoaded", () => {
  // Initialize mobile carousel with a small delay to ensure DOM is ready
  setTimeout(() => {
    initializeMobileCarousel();
  }, 100);
});

// Also initialize when the page is fully loaded
window.addEventListener("load", () => {
  setTimeout(() => {
    initializeMobileCarousel();
  }, 100);
});
